import React, { useMemo, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiEye, FiPaperclip } from "react-icons/fi";
import { download, formatDate } from "utils";
export default function AdminFormalityRequestMessagesCard({ messages = [] }) {
  const [selected, setSelected] = useState(null);
  const sortedMessages = useMemo(() => {
    return [...messages].sort((a, b) => {
      return new Date(b.mmCreatedAt) - new Date(a.mmCreatedAt);
    });
  }, [messages]);
  // =========================
  // STATUS META 
  // =========================
  const getStatusMeta = (status) => {
    if (!status) return { label: "Inconnu", variant: "secondary" };
    const map = {
      draft: { label: "Brouillon", variant: "secondary" },
      queued: { label: "En file d’envoi", variant: "warning" },
      sent: { label: "Envoyé", variant: "info" },
      opened: { label: "Ouvert", variant: "success" },
      error: { label: "Erreur", variant: "danger" },
      success: { label: "Délivré", variant: "success" },
      delivered: { label: "Délivré", variant: "success" },
      processing: { label: "En traitement", variant: "warning" },
      deferred: { label: "Différé", variant: "warning" },
      bounce: { label: "Rebond", variant: "danger" },
      blocked: { label: "Bloqué", variant: "danger" },
      spam: { label: "Classé spam", variant: "danger" },
      unsub: { label: "Désinscrit", variant: "dark" },
      rejected: { label: "Rejeté", variant: "danger" }
    };
    return map[status.toLowerCase()] || {
      label: status,
      variant: "light"
    };
  };
  // =========================
  // ATTACHMENTS
  // =========================
  const parseAttachments = (msg) => {
    if (!msg?.mmAttachmentsJson) return [];
    try {
      return JSON.parse(msg.mmAttachmentsJson) || [];
    } catch {
      return [];
    }
  };
  const extractRecipients = (recipents) => {


  }
  const hasAttachments = (msg) => parseAttachments(msg).length > 0;
  return (
    <>
      <div className="card mb-3">
        <div className="card-header">
          <strong>Messages</strong>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th style={{ width: 40 }} className="bg-light">
                    <FiPaperclip className="text-muted" title="Pièces jointes" />
                  </th>
                  <th className="bg-light">Date</th>
                  <th className="bg-light">De/A</th>
                  <th className="bg-light">A</th>
                  <th className="bg-light">Objet</th>
                  <th className="bg-light">Status</th>

                </tr>
              </thead>
              <tbody>
                {sortedMessages.map((msg) => {
                  const { label, variant } = getStatusMeta(msg.mmStatus);
                  const attachments = parseAttachments(msg);
                  return (
                    <tr key={msg.mmId} onClick={() => setSelected(msg)} >
                      <td className="text-center">
                        {attachments.length > 0 && (
                          <FiPaperclip className="text-muted" />
                        )}
                      </td>
                      <td className="text-center small">
                        {msg.mmSentAt
                          ? formatDate(msg.mmSentAt, 'd/m/Y H:i')
                          : formatDate(msg.mmCreatedAt, 'd/m/Y H:i')}
                      </td>
                      <td>
                        <div className="fw-semibold">{msg.mmFromName}</div>
                        <div className="small text-muted">{msg.mmFromEmail}</div>
                      </td>
                      <td>
                        {msg.mmRecipients?.map((r, i) => (
                          <div key={i}>
                            <div className="fw-semibold">{r.name}</div>
                            <div className="small text-muted">{r.email}</div>
                          </div>
                        ))}
                      </td>
                      <td className="text-truncate" style={{ maxWidth: 250 }}>
                        {msg.mmSubject}
                      </td>
                      <td className="text-center">
                        <span className={` badge bg-${variant}`}>
                          {label}
                        </span>
                      </td>

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div >
      {/* =========================
           MODAL
         ========================= */}
      <Modal
        show={!!selected
        }
        onHide={() => setSelected(null)}
        size="lg"
        centered
      >
        {selected && (() => {
          const { label, variant } = getStatusMeta(selected.mmStatus);
          const attachments = parseAttachments(selected);
          return (
            <>
              <Modal.Header closeButton>
                <Modal.Title>{selected.mmSubject}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3 small">
                  <div>
                    <strong>From :</strong>{" "}
                    {selected.mmFromName} ({selected.mmFromEmail})
                  </div>
                  <div>
                    <strong>To :</strong>{" "}
                    {selected.mmToName} ({selected.mmToEmail})
                  </div>
                  <div>
                    <strong>Date :</strong>{" "}
                    {selected.mmSentAt
                      ? formatDate(selected.mmSentAt)
                      : formatDate(selected.mmCreatedAt)}
                  </div>
                  <div>
                    <strong>Status :</strong>{" "}
                    <span className={`badge bg-${variant}`}>
                      {label}
                    </span>
                  </div>
                </div>
                <hr />
                {/* BODY HTML */}
                <div
                  className="mb-4"
                  dangerouslySetInnerHTML={{
                    __html: selected.mmBodyHtml || "<em>Aucun contenu</em>"
                  }}
                />
                {/* ATTACHMENTS */}
                {attachments.length > 0 && (
                  <>
                    <hr />
                    <h6 className="mb-3">
                      <FiPaperclip className="me-2" />
                      Pièces jointes
                    </h6>
                    <ul className="list-unstyled">
                      {attachments.map((att, i) => (
                        <li
                          key={i}
                          className="d-flex justify-content-between align-items-center border-bottom py-2"
                        >
                          <span className="text-truncate me-3">
                            {att.name}
                          </span>
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={() => download(att.path)}
                          >
                            Télécharger
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </Modal.Body>
            </>
          );
        })()}
      </Modal>
    </>
  );
}